import { emitNotification } from "@impero-com/ui";
import * as Sentry from "@sentry/react";

import { useLegacyControlConfirmationData } from "api/legacy/legacy-control/legacy-control";

// Ideally this should be a query, but we use it after performing programmatic validation
export const useLegacyControlConfirmationDataMutation = () =>
    useLegacyControlConfirmationData({
        mutation: {
            onError: (error) => {
                Sentry.captureException(error);
                emitNotification("error", error.message);
            },
        },
    });
